import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import FavoriteButton from "../../Components/Favourite_button/favourite_button";
import CircleLoading from "../CirculusIndicator/CircleLoading";
import {fetchFavoriteScreenProducts, resetFavoriteScreen } from "../../Features/FavoriteScreen/favoriteScreen";
import './favourite.css';
const FavoritesScreen = () => {
  const dispatch = useDispatch();
  const { products, hasMore, loading } = useSelector((state) => state.favoriteScreen);
  const favoriteProductIds = useSelector((state) => state.favorites.favoriteProducts);
  const isFetched = useRef(false); 

  useEffect(() => {
    if (!isFetched.current && favoriteProductIds.length > 0 && products.length === 0) {
      console.log('Calling favorite useEffect only once');
      isFetched.current = true;
      dispatch(fetchFavoriteScreenProducts(favoriteProductIds));
    }
  }, [favoriteProductIds, dispatch]);

  const fetchMoreFavorites = () => {
    if (hasMore && !loading) {
      dispatch(fetchFavoriteScreenProducts(favoriteProductIds));
    }
  };

  return (
    <div className="favoritesContainer">
      <InfiniteScroll
        dataLength={products.length}
        next={fetchMoreFavorites}
        hasMore={hasMore}
        loader={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircleLoading />
          </div>
        }
        endMessage={<p style={{ textAlign: "center", marginTop: "20px" }}>You've reached the end.</p>}
      >
        <div className="shopDetailsProducts">
          <div className="shopDetailsProductsContainer">
            {products.map((product) => (
              <div key={product.id} className="sdProductContainer">
                <div className="sdProductImages">
                  <Link to={`/product/${product.productId}`} state={{ product }}>
                    <img src={product.images[0]} alt="" className="sdProduct_front" />
                    <img src={product.images[1]} alt="" className="sdProduct_back" />
                  </Link>
                </div>
                <div className="sdProductInfo">
                  <div className="sdProductCategoryWishlist">
                    <FavoriteButton productId={product.productId} />
                  </div>
                  <div className="sdProductNameInfo">
                    <Link to={`/product/${product.productId}`} state={{ product }}>
                      <h5>{product.title}</h5>
                    </Link>
                    <p>
                      {product.hasDiscount ? (
                        <>
                          <span style={{ textDecoration: "line-through", color: "gray", marginRight: "5px" }}>
                            Rs.{product.price}
                          </span>
                          <span style={{ color: "black" }}>Rs.{product.discountPrice}</span>
                        </>
                      ) : (
                        <span>Rs.{product.price}</span>
                      )}
                    </p>
                    <div className="sdProductRatingReviews">
                      <div className="sdProductRatingStar">
                        {Array.from({ length: 5 }).map((_, index) => {
                          const rating = product.totalRating / product.totalPeopleReview;
                          const fullStars = Math.floor(rating);
                          const hasHalfStar = rating - fullStars >= 0.5;
                          if (index < fullStars) {
                            return <FaStar key={index} color="#FEC78A" size={14} />;
                          } else if (index === fullStars && hasHalfStar) {
                            return <FaStarHalfAlt key={index} color="#FEC78A" size={14} />;
                          } else {
                            return <FaRegStar key={index} color="#FEC78A" size={14} />;
                          }
                        })}
                      </div>
                      <span>{product.totalPeopleReview}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default FavoritesScreen;
